import { componentProvider } from 'js-component-framework/es';
import ToggleButton from '@/js/ToggleButton';
import './footer-menu.scss';

/**
 * FooterMenu component.
 */
class FooterMenu {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Set up the accordion.
   */
  init() {
    this.toggleButton = new ToggleButton(this.element, this.options);
  }
}

const footerMenuConfig = {
  name: 'footer-menu-toggle-button',
  component: FooterMenu,
  options: {
    breakpoint: 'midMax',
    shownClass: 'site-footer__menu-container--is-shown',
  },
};

componentProvider(footerMenuConfig);
